import {authorized} from "./ApiClient";
import {LicenseBindingModel, LicenseViewModel, NewLicenseBindingModel} from "./models";

const license = (id: string) => `/license/${encodeURIComponent(id)}`;

// TSA-1 licence administration (SiteAdmin).
export const LicensesApi = {
    getAll: () => authorized<LicenseViewModel[]>('GET', '/license'),

    // Without a key, the API generates one.
    create: (model: NewLicenseBindingModel) => authorized<LicenseViewModel>('POST', '/license', model),

    get: (id: string) => authorized<LicenseViewModel>('GET', license(id)),

    update: (id: string, model: LicenseBindingModel) => authorized<LicenseViewModel>('PUT', license(id), model),

    freeSeat: (id: string, activationId: string) =>
        authorized<void>('DELETE', `${license(id)}/activation/${encodeURIComponent(activationId)}`)
};
